import type { UndefinedOnPartialDeep } from 'type-fest';

import Text from '@ingka/text';
import { translate } from '@repo/phrase';
import type { Service } from '@repo/types/service';

import { formatServiceStatus } from '@/utils/services.utils';

interface Props {
    service: UndefinedOnPartialDeep<Service>;
}

export const ArticleDeliveryStatusText = ({ service }: Props) => {
    if (!service.status || !service.statusCode) {
        return <Text>{translate('services_article_delivery_view_delivery_status_NOT_FOUND')}</Text>;
    }

    const formattedStatusText = formatServiceStatus(service.status);

    return (
        <Text>
            {translate(`services_article_delivery_view_delivery_status_${formattedStatusText}`)} ({service.statusCode})
        </Text>
    );
};
